import React from 'react';
import { StyleSheet, View, Text, Image, Link } from '@react-pdf/renderer';
import { stringOrNumber } from '../../auditorUtils';

function RainwaterTankTemplate({ nodeInfo, image, title, documentLinks }) {
    const styles = StyleSheet.create({
        title: {
            fontSize: 14,
            textAlign: 'center',
            marginBottom: '3%',
        },
        image: {
            width: '90%',
        },
        link: {
            textAlign: 'center',
            fontSize: 9,
            marginBottom: '1vh',
            marginTop: '1vh',
        },
        superscript: {
            fontSize: 5,
            lineHeight: 5,
        },
        columnTitle: {
            flex: 1,
            textAlign: 'center',
            fontSize: 9,
            borderWidth: 1,
            borderStyle: 'solid',
            color: 'red',
            paddingTop: 20,
        },
        // TABLE
        table: {
            padding: 5,
        },
        tableTitle: {
            width: '100%',
            textAlign: 'center',
            fontSize: 12,
            marginBottom: '3vh',
        },
        tableRow: {
            flexDirection: 'row',
        },
        tableCol: {
            flex: 1,
            textAlign: 'center',
            fontSize: 8,
            border: 1,
            padding: 5,
        },
    });

    return (
        <>
            <Text style={styles.tableTitle}>Specifications and Typical Drawings - {title}</Text>
            {image && <Image style={styles.image} src={image} />}
            {documentLinks
                ? documentLinks.map((link, index) => {
                      return (
                          <Link
                              key={link['manufacture_device_document_link']}
                              src={link['manufacture_device_document_link']}
                              style={styles.link}
                          >
                              {link['document_name'] ? link['document_name'] : `document ${index}`}
                          </Link>
                      );
                  })
                : null}
            <View style={styles.table}>
                <View style={styles.tableRow}>
                    <Text style={styles.columnTitle}>Tank Name</Text>
                    <Text style={styles.columnTitle}>Height(m)</Text>
                    <Text style={styles.columnTitle}>
                        Surface Area(m<Text style={styles.superscript}>2</Text>)
                    </Text>
                    <Text style={styles.columnTitle}>Daily Demand(kL/day)</Text>
                    <Text style={styles.columnTitle}>Irrigation Demand(kL/yr)</Text>
                    <Text style={styles.columnTitle}>TOTAL VOL (kL)</Text>
                    <Text style={styles.columnTitle}>REUSE VOL (kL)</Text>
                    <Text style={styles.columnTitle}>DETENTION VOL (kL)</Text>
                    <Text style={styles.columnTitle}>Overflow orifice (mm)</Text>
                </View>
                {nodeInfo.map((node) => {
                    let height;
                    if (
                        node['Reuse Properties - Minimum Draw down height'] &&
                        node['Storage Properties - Depth above overflow (metres)']
                    ) {
                        height = stringOrNumber(
                            +node['Reuse Properties - Minimum Draw down height'] +
                                +node['Storage Properties - Depth above overflow (metres)'],
                        );
                    } else {
                        height = 'N/A';
                    }
                    let totalVolRainwaterTank;
                    if (
                        node['Storage Properties - Depth above overflow (metres)'] &&
                        node['Storage Properties - Surface Area (square metres)'] &&
                        node['Storage Properties - Volume below overflow pipe (kL)']
                    ) {
                        totalVolRainwaterTank = stringOrNumber(
                            +node['Storage Properties - Depth above overflow (metres)'] *
                                +node['Storage Properties - Surface Area (square metres)'] +
                                +node['Storage Properties - Volume below overflow pipe (kL)'],
                        );
                    } else {
                        height = 'N/A';
                    }
                    let volForDetention;
                    if (
                        node['Storage Properties - Depth above overflow (metres)'] &&
                        node['Storage Properties - Surface Area (square metres)']
                    ) {
                        volForDetention = stringOrNumber(
                            +node['Storage Properties - Depth above overflow (metres)'] *
                                +node['Storage Properties - Surface Area (square metres)'],
                        );
                    }

                    return (
                        <View style={styles.tableRow} key={node['Node Name']}>
                            <Text style={styles.tableCol}>
                                {node['Node Name'] ? node['Node Name'] : 'N/A'}
                            </Text>
                            <Text style={styles.tableCol}>{height}</Text>
                            <Text style={styles.tableCol}>
                                {node['Storage Properties - Surface Area (square metres)']
                                    ? stringOrNumber(
                                          +node[
                                              'Storage Properties - Surface Area (square metres)'
                                          ],
                                      )
                                    : 'N/A'}
                            </Text>
                            <Text style={styles.tableCol}>
                                {node['Reuse Properties - Daily Demand Value (ML/day)']
                                    ? stringOrNumber(
                                          +node['Reuse Properties - Daily Demand Value (ML/day)'] *
                                              1000,
                                      )
                                    : 'N/A'}
                            </Text>
                            <Text style={styles.tableCol}>
                                {node['Reuse Properties - Annual Demand Value (ML/year)']
                                    ? stringOrNumber(
                                          +node[
                                              'Reuse Properties - Annual Demand Value (ML/year)'
                                          ] * 1000,
                                      )
                                    : 'N/A'}
                            </Text>
                            <Text style={styles.tableCol}>{totalVolRainwaterTank}</Text>
                            <Text style={styles.tableCol}>
                                {node['Storage Properties - Volume below overflow pipe (kL)']
                                    ? stringOrNumber(
                                          +node[
                                              'Storage Properties - Volume below overflow pipe (kL)'
                                          ],
                                      )
                                    : 'N/A'}
                            </Text>
                            <Text style={styles.tableCol}>{volForDetention}</Text>
                            <Text style={styles.tableCol}>
                                {node['Outlet Properties - Overflow Pipe Diameter (mm)']
                                    ? node['Outlet Properties - Overflow Pipe Diameter (mm)']
                                    : 'N/A'}
                            </Text>
                        </View>
                    );
                })}
            </View>
        </>
    );
}

export default RainwaterTankTemplate;
